// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2JvHX","content":"Consent_content__KFNkk","footer":"Consent_footer__ffhU2"};